import type { CoreFetch } from '~/types/CoreFetch'

export function provideCuratorRefreshCache(coreFetch: CoreFetch) {
  return function (influencerId: number) {
    return coreFetch.$get<{ done: true }>(
      `/influencer/influencer/${influencerId}/refresh_cache/`,
    )
  }
}
